import React from 'react';
import { Layout } from '../components/layout';
import SEO from '../components/SEO';
import Hreflang from '../components/Hreflang';
import { 
  HeroSection, 
  LaunchAnnouncementsSection,
  AuthorityHeadline,
  ImpactMetrics,
  ProjectsPortfolio,
  WhyChooseUs, 
  ContactCTA 
} from '../components/sections';

export default function HomePage() {
  return (
    <Layout>
      <SEO 
        title="G Developments | Official Website" 
        description="G Developments is a leading Egyptian real estate developer delivering premium residential, commercial, and coastal projects across Egypt."
      />
      <Hreflang enPath="/" arPath="/ar/" currentLang="en" />
      <HeroSection />
      <LaunchAnnouncementsSection />
      <AuthorityHeadline />
      <ProjectsPortfolio />
      <ImpactMetrics />
      <WhyChooseUs />
      <ContactCTA />
    </Layout>
  );
}
